<template>
  <layout title="Veículos" :options="options" :rotas="rotas">
    <v-sheet
      :dark="$theme.dark"
      :light="$theme.light"
      class="expande-horizontal sheet-container pt-2"
    >
      <v-flex xs12 class="pr-1" lg3>
        <Filters :filter="filter" />
        <List :filtereds="filtereds" />
        <EmptyList
          v-if="filtereds.length === 0"
          :iniciarCadastro="iniciarCadastro"
        />
        <v-fab-transition>
          <v-btn
            @click="iniciarCadastro"
            :color="$theme.primary"
            dark
            absolute
            bottom
            right
            fab
            style="bottom: 30px;"
          >
            <v-icon color="#333">mdi-plus</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-flex>
      <v-flex v-if="$vuetify.breakpoint.lgAndUp" xs12 md9 lg9>
        <ViewForm v-if="get_veiculo.new || get_veiculo._id" />
      </v-flex>
      <v-dialog
        v-else
        transition="slide-x-transition"
        fullscreen
        :value="get_veiculo._id || get_veiculo.new ? true : false"
      >
        <v-card>
          <ViewForm />
        </v-card>
      </v-dialog>
    </v-sheet>
  </layout>
</template>

<script>
import EmptyList from "../components/EmptyList.vue";
import Filters from "../components/Filters.vue";
import List from "../components/List.vue";
import ViewForm from "../components/ViewForm.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    EmptyList,
    Filters,
    List,
    ViewForm
  },
  data() {
    return {
      filter: {},
      options: [
        {
          nome: "Novo veículo",
          action: this.iniciarCadastro,
          icon: "mdi-plus"
        }
      ],
      rotas: [
        {
          name: "Início",
          path: "/dashboard"
        },
        {
          name: "Veículos",
          path: "/veiculos"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["get_veiculo", "get_veiculos", "getPersonalizedLoading"]),
    filtereds() {
      const docs = this.get_veiculos.docs || [];
      if (!this.filter.search) return docs;

      const term = this.filter.search.toLowerCase();
      return docs.filter(item => {
        return (
          (item.placa && item.placa.toLowerCase().includes(term)) ||
          (item.modelo && item.modelo.toLowerCase().includes(term)) ||
          (item.capacidade && item.capacidade.toLowerCase().includes(term))
        );
      });
    }
  },
  methods: {
    ...mapActions([
      "listar_veiculos",
      "setPersonalizedLoading",
      "createConfirmAction"
    ]),
    iniciarCadastro() {
      this.setPersonalizedLoading("animate__fadeOutTopRight");
      this.$store.commit("set_veiculo", { new: true, ativo: true });
      this.setPersonalizedLoading("animate__fadeInUp");
    }
  },
  created() {
    this.listar_veiculos();
  }
};
</script>

<style scoped>
.sheet-container {
  min-height: 95vh;
  max-height: 95vh;
  overflow: hidden;
}
</style>
